import { Modal } from "react-bootstrap";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import withPermission from "../../../core/common/autorisations/withPermission";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import {
  generateAnnualReductionReport,
  generateAnnualBourseReport,
} from "../../../api/bourse_remise";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import { Spin } from "antd";

//Typage des props parents
type Props = {
  show: boolean;
  reportType: "Bourses" | "Reductions" | null;
  onClose: () => void;
};
const AnnualRapportDiscountModalApercu = ({
  show,
  reportType,
  onClose,
}: Props) => {
  const { selectedYear } = useAcademicYear();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);

  // Fonction pour télécharger le PDF
  // 🔽 Personnalisation du nom du fichier
  // const handleDownload = () => {
  //   const url = metaData?.pdfBlobUrl;
  //   if (!url) return;

  //   // Créer un lien temporaire
  //   const a = document.createElement("a");
  //   a.href = url;

  //   // 🔽 Personnalisation du nom du fichier
  //   const nomEtudiant = metaData?.studentName || "Etudiant";
  //   const cycle = metaData?.cycleLabel || "Cycle";
  //   const annee = metaData?.academicYear || "Annee";

  //   a.download = `Certificat_${nomEtudiant}_${cycle}_${annee}.pdf`;
  //   a.click();
  // };

  // Fontion pour générer un relevé denotes selon la périod , année academique , la classe et l'étudiant
  const generateReport = async () => {
    setIsLoading(true);
    try {
      // console.log("MetaData: ", metaData);
      const payload = { id_academicYear: selectedYear?.id };
      const response =
        reportType === "Bourses"
          ? await generateAnnualBourseReport(
              payload,
              buildPermissionContext(Resource.BOURSE_REMISE, Action.READ),
            )
          : await generateAnnualReductionReport(
              payload,
              buildPermissionContext(Resource.BOURSE_REMISE, Action.READ),
            );
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      // console.log("relevé généré: ", response);
      toast.success("Rapport généré avec succès");
    } catch (error: any) {
      // console.log("erreur génération rapport: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false); // ← Toujours arrêter le chargement à la fin
    }
  };

  useEffect(() => {
    if (show) {
      generateReport();
    } else {
      setPdfBlobUrl(null);
    }
  }, [show, reportType]);

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Rapport Annuel des {reportType}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {!pdfBlobUrl && isLoading ? (
              <Spin
                indicator={
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              />
            ) : (
              <iframe
                src={pdfBlobUrl || ""}
                style={{ width: "100%", height: "100%" }}
                title="Aperçu PDF Rapport Annuel(Bourse / Remise)"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  AnnualRapportDiscountModalApercu,
  [buildPermission(Resource.BOURSE_REMISE, Action.READ)],
  "masquer",
);
